import { useIntl } from 'react-intl';

import { RoadmapSubscriptionForm } from './roadmap-subscription-form.tsx';

export interface DataCenterRoadmapSubscriptionFormProps {
	lastUpdated: string;
}

export const DataCenterRoadmapSubscriptionForm = (
	props: DataCenterRoadmapSubscriptionFormProps,
) => {
	const { lastUpdated } = props;

	const intl = useIntl();

	return (
		<RoadmapSubscriptionForm
			lastUpdated={lastUpdated}
			formId="16f4d97b-db1e-49ba-9edd-61a5ae678459"
			formImage={{
				src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2nl3q4f4uqjjnr853405jk53476o6r8r.png',
				alt: intl.formatMessage({
					id: 'roadmapSubscription.data-center.image.alt',
					defaultMessage: 'Data Center Roadmap',
				}),
			}}
			heading={intl.formatMessage({
				id: 'roadmapSubscription.data-center.heading',
				defaultMessage: 'Data Center Roadmap',
			})}
			description={intl.formatMessage({
				id: 'roadmapSubscription.data-center.description',
				defaultMessage:
					'Check out the latest features in Data Center and learn about what we’re working on. Subscribe to receive an email each quarter highlighting our newly released features, updated time frames, and more.',
			})}
		/>
	);
};
